@import (reference) '../../../../../constants/spacing.module.less';
@import (reference) '../grid-layouts.module.less';

@two-column-breakpoint: 420px;
@three-column-breakpoint: 580px;
@four-column-breakpoint: 700px;

.shipment-details-grid-container {
  container-type: inline-size;
}

.shipment-details-grid {
  flex: 1;
  display: grid;
  justify-content: start;

  .shipment-details-one-column-grid-layout();
}

.shipment-divider {
  display: none;
}

@container (min-width: @two-column-breakpoint) {
  .shipment-details-grid {
    .shipment-details-two-column-grid-layout();
  }
}

@container (min-width: @three-column-breakpoint) {
  .shipment-details-grid {
    .shipment-details-three-column-grid-layout();
  }
  .shipment-divider {
    display: block;
  }
}

@container (min-width: @four-column-breakpoint) {
  .shipment-details-grid {
    .shipment-details-four-column-grid-layout();
  }
  .shipment-divider {
    display: block;
  }
}
